export const plusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAAHlBMVEUAAAA/P0c+Pkc+Pkg9PUY9PUc+PkY9PUc+Pkg9PUcsigVLAAAACnRSTlMAZcqA/2R/v3z5NOdiagAAAC9JREFUeAFjgAEhRQZ0YOKMITQqFJYGASXuUEYGg4oLGvDEJoSpkRgbR4U6Z8BYAIiNJrvd1a3TAAAAAElFTkSuQmCC";

export default {
  plusIcon
};

